import debounce from 'lodash/debounce';
import { calcOffsetBoxesSize } from '../../../scripts/utils/offsetBoxes';
import Vue from '../../../../theme/assets/vue';

const QuizSteps = {
  data() {
    this.STEPS = {
      START: 'start',
      SIZE: 'size',
      BRANDS: 'brands',
      INTERCOM: 'intercom',
    };

    this.SIZE_ANSWERS = {
      STUDIO: 'studio',
      SMALL: 'small',
      MEDIUM: 'medium',
      LARGE: 'large',
    };

    // NOTE: uses in template
    this.INTERCOM_ANSWERS = {
      VERY: 'very',
      SOMEWHAT: 'somewhat',
      NOT_AT_ALL: 'not_at_all',
    };

    return {
      stepNameActive: this.STEPS.START,
      isDropDownClose: true,
      selectedSizeStepName: null,
      selectedIntercomStepName: null,
      showIntroductionAnimation: false,
    };
  },
  computed: {
    resultUrl() {
      const sizeValue = this.selectedSizeStepName
        ? this.selectedSizeStepName
        : this.SIZE_ANSWERS.STUDIO;

      return `/collections/quiz-results?size=${sizeValue}`;
    },
  },
  methods: {
    isStepActive(stepName) {
      return stepName === this.stepNameActive;
    },
    goToStep(stepName) {
      this.stepNameActive = stepName;
    },
    openMobileMenu(open) {
      this.isDropDownClose = !open;
    },
    selectAnswerSizeStep(sizeStepName) {
      this.selectedSizeStepName = sizeStepName;
      this.openMobileMenu(false);
    },
    selectAnswerIntercomStep(intercomStepName) {
      this.selectedIntercomStepName = intercomStepName;
    },
  },
  mounted() {
    this.showIntroductionAnimation = true;
  },
};

export const initQuizSteps = () => {
  if (document.querySelector('[data-section="quiz-steps"]')) {
    new Vue(QuizSteps).$mount('[data-section="quiz-steps"]');
  }
};

export const setQuizStepsHeight = () => {
  setQuizMinHeight();

  window.addEventListener('resize', debounce(setQuizMinHeight, 50));
};

function setQuizMinHeight() {
  const quizContainer = document.querySelector('[data-quiz-steps]');

  if (quizContainer) {
    const quizMinHeight = window.innerHeight - calcOffsetBoxesSize();

    quizContainer.style.minHeight = `${quizMinHeight}px`;
  }
}
